import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

export class OpenNewEmployeeDialogCommand extends AbstractCommand<void> {

    public name: CommandName = CommandName.OPEN_NEW_EMPLOYEE_DIALOG;

    public tags = ['ui', 'dialog', 'employee', 'create'];

    constructor() {
        super('employee', 'new', undefined);
    }
}